import React from "react";
import { ElfsightWidget } from 'react-elfsight-widget';
import Header from './components/Header/Header.jsx';
import Main from './components/main/main.jsx';
import Numbers from './components/Numbers/Numbers.jsx';
import Translation from './components/Translation/Translation.jsx';
import SpeakersFrom from './components/Speakers from/Speakers from.jsx';
// import WhatIWillLearn from './components/WhatIWillLearn/WhatIWillLearn.jsx';
import FourKeys from './components/FourKeys/FourKeys.jsx';
// import FAQ from './components/FAQ/FAQ.jsx';
import Audience from './components/Audience/Audience.jsx';
import Photos from './components/Photos/Photos.jsx';
import TagCloud from './components/TagCloud/TagCloud.jsx';
import Speakers from './components/Speakers/Speakers.jsx';
import Event_about from './components/Event_about_real/Event_about.jsx';
import Packages from './components/Packages/Packages.jsx';
import AskCompany from "./components/AskCompany/AskCompany";
import Enterprise from "./components/Enterprise/Enterprise";
// import Workshops from "./components/Workshops/Workshops";
import Become from "./components/Become/Become";
// import Sponsors from "./components/Sponsors/Sponsors";
import Partners from "./components/Partners/Partners";
import PC from "./components/PC/PC";
import Mission from "./components/Mission/Mission";
import Reviews from './components/Reviews/Reviews.jsx';
// import JoinCommunity from './components/JoinCommunity/JoinCommunity';
import Team from './components/Team/Team.jsx';
import Countdown from './components/CountDown/CountDown';
import Description from './components/Description/Description';
import Announce from './components/Announce/Announce';
import Upcoming from './components/Upcoming/Upcoming';
import Topics from './components/Topics/Topics';
import Agenda from './components/Agenda/Agenda';

const Content = (props) => {
    return (
      <main>
        <Header />
        <Main />
        {/* <Description /> */}
        <Upcoming />
        <Translation />
        <Numbers />
        <SpeakersFrom />
        {/* <Topics /> */}
        {/* <WhatIWillLearn /> */}
        {/* <FAQ /> */}
        <Audience />
        <Photos />
        <Event_about />
        {/* <TagCloud /> */}
        {/* <FourKeys /> */}
        <Speakers />
        <Packages />
        <Agenda />
        {/* <Announce /> */}
        <AskCompany />
        <Enterprise />
        <Become />
        {/* <Workshops /> */}
        {/* <Sponsors /> */}
        <Partners />
        <PC />
        <Reviews />
        {/* <JoinCommunity /> */}
        <Team />
        <Mission />
        <Countdown />
        <ElfsightWidget widgetID="92a60721-d728-4f10-ad28-ec12905efbd9" />
      </main> 
    );
  }
  
  export default Content;
